import axios from '../../../lib/axios'
import { employeeFiles } from '../../../lib/apiList'
// import { UpoloadFileValues } from '../uploadfile/types'

interface GetEmpFileParams {
    currentPage: number
    recordsPerPage: number
    role: string
}

const uploadEmployeeFiles = async (empFile: FormData): Promise<any> => {
    const response = await axios.post(
        employeeFiles.UPLOAD_EMPLOYEE_FILES,
        empFile
    )
    return response.data
}

const loadAllEmployeeFiles = async ({
    currentPage,
    recordsPerPage,
    role,
}: GetEmpFileParams): Promise<any> => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 5,
        pageNumber: currentPage ? currentPage : 1,
    }
    const response = await axios.post(
        role === 'Admin' || role === 'Executive Director'
            ? employeeFiles.GET_ALL_EMPLOYEE_FILES
            : employeeFiles.GET_EMPLOYEE_FILE_NO_ADMIN,
        data
    )
    return response.data
}

const deleteEmpFile = async (id: string): Promise<any> => {
    const response = await axios.post(employeeFiles.DELETE_EMPLOYEE_FILES, {
        employeeFileId: id,
    })
    return response.data
}

const loadAssignment = async (id: string): Promise<any> => {
    const response = await axios.get(employeeFiles.GET_EMPLOYEE_FILE + id)
    return response.data
}
const loadAllUsers = async (): Promise<any> => {
    const response = await axios.get(employeeFiles.GET_ALL_USERS_LIST)
    return response.data
}
const downloadEmpFile = async (id: string) => {
    const url = employeeFiles.DOWNLOAD_EMP_FILE.replace(':resourceID', id)
    const response = await axios.post(url + '?type=File', {
        resourceId: id,
        type: 'File',
    })
    return response
}
export {
    loadAllUsers,
    uploadEmployeeFiles,
    loadAllEmployeeFiles,
    deleteEmpFile,
    loadAssignment,
    downloadEmpFile,
}
